/* eslint-disable import/no-anonymous-default-export */
export default {
  copyright: "Copyright",
  "footer.companyPrefix": "A",
  "navBar.lang": "Languages",
  "layout.user.link.help": "help",
  "layout.user.link.privacy": "privacy policy",
  "layout.user.link.terms": "terms of service",
  "app.home.introduce": "Help",
  "app.forms.basic.title": "Basic form",
  "app.forms.basic.description":
    "Form pages are used to collect and verify user information and basic forms are common in scenarios where there are some information formats.",

  areYouSureYouWantToAccept: "Are you sure you want to accept?",
  areYouSureYouWantToRemove: "Are you sure you want to delete?",
  areYouSureYouWantToEdit: "Are you sure you want to edit?",
  areYouSureYouWantToClone: "Are you sure you want to clone?",
  areYouSureYouWantToUndo: "Are you sure you want to undo?",
  areYouSureYouWantToCancel: "Are you sure you want to cancel?",
  dataRecoveredSuccessfully: "Data recovered successfully",
  "yes.IWant": "Yes, I want",
  youDontHavePermission: "You do not have permission to perform this action.",
  loading: "...",
  pleaseWait: "Please wait",
  ok: "Ok",
  others: "Other(s)",
  number_of_visitors: "Number of clients",
  transfer: "Transfer",
  hasten: "Advance (withdrawal)",
  "loading-more": "Load more",
  version: "Version",
  shortVersion: "v",
  refresh: "Refresh",
  search: "Search",
  continue: "Continue",
  edit: "Edit",
  cancel: "Cancel",
  close: "Close",
  submit: "Save",
  status: "Status",
  reset: "Clear",
  options: "Options",
  settings: "Settings",
  general: "General",
  email: "Email",
  cellphone: "Cell phone",
  telephone: "Phone",
  create: "Create",
  update: "Update",
  delete: "Delete",
  clone: "Clone",
  resendEmail: "Resend email",
  language: "Language",
  all: "All",
  "picture.upload": "Upload",
  "picture.remove": "Remove image",
  "picture.onDrag": "Drop Here",
  add: "Add",
  balanceTotal: "Total Balance",
  balanceNotConciliationTotal: "Total Balance",
  balanceConciliationTotal: "Reconciled Balance",
  balanceNotRevenueTotal: "Expected",
  balanceRevenueTotal: "Realized",
  enabled: "Active",
  disabled: "Inactive",
  createdAt: "Created at",
  updatedAt: "Updated at",
  acceptedAt: "Accepted at",
  canceledAt: "Canceled at",
  createdBy: "Created by",
  updatedBy: "Updated by",
  acceptedBy: "Accepted by",
  requestBy: "Requested by",
  canceledBy: "Canceled by",
  dateFormat: "DD/MM/YYYY",
  statement: "Statement",
  until: "until",
  today: "Today",
  yesterday: "Yesterday",
  lastFortnight: "Last 15 days",
  nextFortnight: "Next 15 days",
  thisMonth: "This Month",
  thisYear: "1 Year (From today)",
  goBack: "Go back",
  calendar: "Calendar",
  lastUpdate: "Last update",

  filteredBy: "Filtered by",
  filter: "Filter",
  "filter.clean": "Clear Filters",

  "link.expired": "Expired link",

  mail_sent: "Email sent",
  mail_sent_to: "Email sent to",
  "send.to.mail": "Send by Email",
  "recovery.with.success": "Updated successfully!",
  "follow.procedure.sent.email": "Follow the procedure sent to email",
  "button.create": "Create",
  "button.new": "New",
  "button.new.link": "New link",
  "button.add": "Add",
  "button.add.and.choice": "Add and Use",
  "button.update": "Update",
  "button.update.and.choice": "Update and Use",
  "button.select": "Select",
  "button.select.recipient": "Select recipient(s)",
  "button.send": "Send",
  "button.share": "Share",
  "button.download": "Download",
  "button.download.loadingMessage":
    "Your file is being processed, when ready it will be available to you (do not reload the page)",
  "button.view": "View",
  "button.copy": "Copy",
  "button.copy.success": "Copied successfully",
  "button.copy.link": "Copy link",
  "button.copy.link.success": "Link copied successfully",

  "clean.selected": "Clear selection",
  "items.selected": "Item(s) selected ",
  "yesno.true": "Yes",
  "yesno.false": "No",
  "yes.confirm": "Confirm",
  "no.cancel": "Cancel",
  "no.close": "Close",
  "yes.finish": "Finish",
  "joinplace.welcome": "Managing PROJECTS, building dreams.",
  "joinplace.slogan": "All your projects meet here",
  "joinplace.slogan.register": "Your registration is being created",
  "joinplace.welcome.register": "Building dreams...",
  "joinplace.aboutus": "About Joinplace",
  "joinplace.benefits": "Benefits",
  "joinplace.visitus": "Visit our website",

  production: "Production",
  homologation: "Homologation",
  "normalizeRule.SOURCE": "Same as source",
  "normalizeRule.NUMERIC": "Numbers only",
  "normalizeRule.ZERO_NUMERIC": "Numbers only and Initial zero inclusion",
  "normalizeRule.ZERO": "Initial zero inclusion",

  "provided.conducted": "Expected / Realized",
  service: "Service",
  revenue: "Revenue",
  received: "Received",
  late: "Late",
  expenses: "Expenses",
  paidOut: "Paid",
  predicted: "Expected",
  choose: "Choose",

  "modal.close.title": "Are you sure you want to leave?",
  "modal.close.description":
    "If you leave you will lose the changed information without saving.",

  nextInvoice: "Next invoice",
  "nextInvoice.message": "The next bill will be available on day ",

  total: "Total",
  value: "Value",
  date: "Date",

  next: "Next",
  previous: "Previous",
  done: "Finish",
  export: "Export",
  import: "Import",

  empty: " ",

  "required.message": "is required",
  "insert.message": "Please enter the",

  I: "I, {name},",
  "terms.confirm.description.terms": `confirm that I have read and accept the`,
  "terms.confirm.description.privacy": `and the`,
  "terms.confirm.description.joinplace": `of the Joinplace platform`,

  "resend.mail.success.message": "Email sent successfully.",
  "resend.mail.error.message": "An error occurred while sending the email.",

  without_message: "No Information",

  file: "File",
  "upload.click-or-drag-file-text":
    "Click or drag the file to this area to upload",
  "upload.click-or-drag-file-cert.hint":
    "Support for single upload with extensions .pfx or .pcs12",
  "upload.click-or-drag-file-ofx.hint":
    "Support for single upload with extension .ofx",
  "upload.click-or-drag-file-default.hint":
    "Support for single or multiple upload with extensions .xls, .xlsx, .doc, .docx, .pdf, .png, .jpg, .txt",

  "upload.failed.message": "failed to upload",
  "upload.success.message": "uploaded successfully",
  "upload.removed.message": "removed successfully",
  "upload.failed.removed.message": "failed to be deleted",

  "btnShowCurrency.true": "Hide values",
  "btnShowCurrency.false": "Show values",

  "taxNumber.choose.type": "Choose the type of person",
  "taxNumber.validate.PP.message": "Please enter a valid CPF.",
  "taxNumber.validate.LP.message": "Please enter a valid CNPJ.",
  "email.invalid.message": "Please enter a valid email.",

  "nickname.validate.character": "Must contain only special characters . _ -",
  "nickname.validate.space": "Cannot contain blank spaces.",
  "nickname.validate.smallLetters": "Must contain only lowercase letters.",
  "nickname.validate.maxLenght": "Must contain maximum 32 characters.",
  store: "Storage",
  users: "Users",
  in: "of",
  used: "used",
  "page.title.projectItemList": "Shared Items",
};
